// extracted by mini-css-extract-plugin
module.exports = {"block":"_16238","inclusion":"_17283","title":"_2470","content":"_583","desc":"_14309","line":"_19787","text":"_19499","more":"_17832","arrow":"_4062","fold":"_11597"};